// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"BokCM","checkbox":"_3aQf1","content":"_1eEcu","dot":"EnthE"};